import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import T, { Translate } from '../../../i18n/i18n';
import { Container, ItemRow, ItemName, ItemValue, ConfirmMessage } from './TurnOrderListing.styles';
import { Button, ButtonRow, ButtonIcon } from '../../../../styles/globalComponents';

export default ({value, onClickAdd, onClickEdit, onClickRemove, onClickMoveUp, onClickMoveDown, onClickConfig}) => {

    const items = useSelector(state => state.turnorderState.items);
    const isOwner = useSelector(state => state.authState.isOwner);

    const [selectedItem, setSelectedItem] = useState(null);
    const [isRemoving, setIsRemoving] = useState(false);

    useEffect(()=>{
        setSelectedItem(value);
    },[value]);

    const handleAdd = () => {
        if (!isOwner) {
            return;
        }

        if (typeof onClickAdd === 'function') {
            onClickAdd()
        }
    };

    const handleItemClick = (item) => {
        if (!isOwner) {
            return;
        }
        
        setSelectedItem(item);
    };

    const handleUnselect = (item) => {
        if (!isOwner) {
            return;
        }
        
        setSelectedItem(null);
    };

    const handleEdit = (item) => {
        if (!isOwner) {
            return;
        }
        
        if (typeof onClickEdit === 'function') {
            onClickEdit(item)
        }
    };

    const handleRemove = () => {
        if (!isOwner) {
            return;
        }
        
        setIsRemoving(true);
    };

    const handleConfirmDelete = () => {
        if (!isOwner) {
            return;
        }
        
        setIsRemoving(false);
        if (typeof onClickRemove === 'function') {
            onClickRemove(selectedItem);
        }
    };

    const handleNoDelete = () => {
        if (!isOwner) {
            return;
        }
        
        setIsRemoving(false);
    };

    const handleMoveUp = () => {
        if (!isOwner) {
            return;
        }
        
        if (typeof onClickMoveUp === 'function') {
            onClickMoveUp(selectedItem);
        }
    };

    const handleMoveDown = () => {
        if (!isOwner) {
            return;
        }
        
        if (typeof onClickMoveDown === 'function') {
            onClickMoveDown(selectedItem);
        }
    };

    const handleConfig = () => {
        if (!isOwner) {
            return;
        }
        
        if (typeof onClickConfig === 'function') {
            onClickConfig()
        }
    };

    return <Container className={"scrollbar"}>
        {items.length ? 
            items.map(item => <ItemRow className={(selectedItem && selectedItem.id === item.id ? 'selected' : '') + (item.first ? ' first' : '') + (item.last ? ' last' : '')} key={item.id} onClick={()=> handleItemClick(item)}>
                <ItemName>{item.name}</ItemName>
                <ItemValue>{item.value}</ItemValue>
            </ItemRow>)
        :
            null
        }

        { isOwner ? (
            isRemoving ? <>
                <ButtonRow className="padding10">
                    <ConfirmMessage><T value="turnorder.confirmDelete" /></ConfirmMessage>
                    <ButtonIcon icon="\F012C" color="#f33" onClick={()=>{handleConfirmDelete(selectedItem)}} title={Translate("yes")} />
                    <ButtonIcon icon="\F0156" color="#0c0" onClick={()=>{handleNoDelete(selectedItem)}} title={Translate("no")} />
                </ButtonRow>
            </> 
                : (selectedItem ? <ButtonRow className="padding10">
                    <ButtonIcon icon="\F004D" color="#f33" onClick={handleUnselect} title={Translate("turnorder.back")} />
                    <ButtonIcon icon="\F064F" color="#36f" onClick={()=>{handleEdit(selectedItem)}} title={Translate("turnorder.edit")} />
                    <ButtonIcon icon="\F0A79" color="#fa3" onClick={handleRemove} title={Translate("delete")} />
                    <ButtonIcon icon="\F0737" color="#3af" onClick={handleMoveUp} title={Translate("turnorder.moveUp")} />
                    <ButtonIcon icon="\F072E" color="#3fa" onClick={handleMoveDown} title={Translate("turnorder.moveDown")} />
                </ButtonRow> : <ButtonRow className="padding10">
                    <Button color="#0c0" onClick={handleAdd}><T value="turnorder.add" /></Button>
                    <ButtonIcon color="#06f" icon="\F0493" onClick={handleConfig}/>
                </ButtonRow>)
        ) : null }
    </Container>
}